import { createStyles, makeStyles } from '@material-ui/core';
import { Colors } from '../../layout/theme-next';

export default makeStyles((theme) =>
  createStyles({
    attachmentHeader: {
      backgroundColor: Colors.hover,
      color: Colors.textBlack,
      fontWeight: 600,
      fontSize: 12,
      fontFamily: 'inherit',
      textAlign: 'left',
      width: '100%',
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      lineHeight: '15px',
      height: 44,
      borderRadius: 4,
      border: `1px solid ${Colors.tableStroke}`,
      cursor: 'pointer',
      padding: theme.spacing(0, 2),
    },
    expandIcon: {
      transition: 'transform 0.3s ease-in-out',
      transform: 'rotate(0deg)',
    },
    expandIconRotated: {
      transform: 'rotate(180deg)',
    },
  }),
);
